import React from "react";
import { Button } from "../../../controls";
import { useTranslation } from "react-i18next";

const SubmitSale = ({ handleSubmit }) => {
  const { t } = useTranslation();
  return (
    <div className="w-100pr" style={{ marginTop: "20px" }}>
      <Button
        color="error"
        fullWidth
        sx={{
          fontSize: { lg: "20px", sm: "16px" },
        }}
        onClick={handleSubmit}
      >
        {t("submit")}
      </Button>
    </div>
  );
};

export default SubmitSale;
